import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { UIModelComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';

export class UIModelComponentExtend {
  public static Init(dto: UIModelComponent) {
    dto.componentType = EnumComponentType.UIModel;
  }
}
